import { render, staticRenderFns } from "./TestimonialsContent.vue?vue&type=template&id=1e225c41&scoped=true&"
import script from "./TestimonialsContent.vue?vue&type=script&lang=js&"
export * from "./TestimonialsContent.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsContent.vue?vue&type=style&index=0&id=1e225c41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e225c41",
  null
  
)

export default component.exports